module.exports = __webpack_public_path__ + "static/media/ico-hired.b5ce4ea6.svg";